var COS = require('cos-js-sdk-v5');
import {UpdateAPI} from '../Update/Update';

var cos = new COS({
    // getAuthorization 必选参数
    getAuthorization: function (options, callback) {
      let api = UpdateAPI()
      api.getCos().then(res => {
        callback({
          TmpSecretId: res.data.credentials.tmpSecretId,
          TmpSecretKey: res.data.credentials.tmpSecretKey,
          SecurityToken: res.data.credentials.sessionToken,
          // 建议返回服务器时间作为签名的开始时间，避免客户端本地时间偏差过大导致签名错误
          StartTime: res.data.startTime, // 时间戳，单位秒，如：1580000000
          ExpiredTime: res.data.expiredTime, // 时间戳，单位秒，如：1580000000
          ScopeLimit: true, // 细粒度控制权限需要设为 true，会限制密钥只在相同请求时重复使用
        });
      })
    }
});
export default cos;